import React, { useEffect, useState } from "react";
import styles from "./RouteLoader.module.css";

// Espera breve: cambio de página y cargas de datos. Antes era una brújula
// grande en el centro de una página vacía; ahora una barra fina arriba,
// como en la mayoría de webs, y la página conserva su sitio.
// Con retardo: si la carga dura <250 ms no se pinta nada (sin parpadeo).
// El loader con mensajes («Buscando joyas locales…») es solo para cuando
// la IA genera un viaje, que sí tarda.
export default function RouteLoader() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 250);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={styles.wrapper} role={show ? "status" : undefined} aria-live="polite">
      {show && (
        <div className={styles.bar} aria-label="Cargando">
          <span className={styles.runner} />
        </div>
      )}
    </div>
  );
}
